import { TODO } from '@b2b/types/core';

export interface TempDefinition {
  id: string;
  name: string;
  description: string;
  displayCollectionName: string;
  queryExpression: {
    collectionName: string;
    limit: number;
  };
  customReport: boolean;
  createdOn: string;
  createdBy: string;
  updatedOn: string;
  updatedBy: string;
  isCurrentUserReportOwner: boolean;
  acmeDefault: boolean;
}

export interface Definition {
  id: string;
  createdBy: string;
  createdOn: string;
  name: string;
  description: string;
  displayCollectionName: string;
  updatedBy: string;
  updatedOn: string;
  acmeDefault: boolean;
  queryExpression: {
    collectionFullName: string;
    findFields: TODO[];
    findQueries: TODO[];
    groupFields: TODO[];
    limit: number;
    sortFields: TODO[];
    summaryFields: TODO[];
    countFields: TODO[];
  };
  userGroups: TODO[];
  customReport?: TODO;
}

export function createQueryExpression(
  values: Partial<Definition['queryExpression']> = {}
): Definition['queryExpression'] {
  return {
    collectionFullName: '',
    findFields: [],
    findQueries: [],
    groupFields: [],
    limit: 0,
    sortFields: [],
    summaryFields: [],
    countFields: [],
    ...values,
  };
}

export function createDefinition(values: Partial<Definition> = {}): Definition {
  return {
    id: '',
    createdBy: '',
    createdOn: '',
    name: '',
    description: '',
    displayCollectionName: '',
    updatedBy: '',
    updatedOn: '',
    acmeDefault: false,
    queryExpression: createQueryExpression(values.queryExpression),
    userGroups: [],
    customReport: undefined,
    ...values,
  };
}
